import { useSelector } from 'react-redux';

import {
  DisplayAvatarIcon1,
  DisplayAvatarIcon2,
  DisplayAvatarIcon3,
  DisplayAvatarIcon4,
  DisplayNoAvatarIcon,
} from './DisplayAvatarIconList';
import { StyledAvatar } from './DisplayProfilePictureStyled';

interface DisplayAvatarIconType {
  enrollment: {
    chooseAvatar: {
      avatar: {
        id: string;
      };
      avatarSkinTone?: {
        colorCode?: string | undefined;
      };
      avatarHairColor?: {
        colorCode?: string | undefined;
      };
      avatarShirtColor?: {
        colorCode?: string | undefined;
      };
      family_avatar?: { id: string };
      avatarFamilySkinTone?: { colorCode: string | undefined };
      avatarFamilyHairColor?: { colorCode: string | undefined };
      avatarFamilyShirtColor?: { colorCode: string | undefined };
    };
  };
}

export const DisplayAvatarIcon = () => {
  const chooseAvatarPicture = useSelector(
    (state: DisplayAvatarIconType) => state?.enrollment?.chooseAvatar
  );

  const chooseAvatarPictureRedirection = useSelector(
    (state: any) => state?.enrollment?.authentication?.redirectLink
  );

  const avatarSvgIcon1RenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatar?.id === 'avatarSvgIcon1'
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.family_avatar?.id === 'avatarSvgIcon1'
        : null;
  const avatarSvgIcon2RenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatar?.id === 'avatarSvgIcon2'
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.family_avatar?.id === 'avatarSvgIcon2'
        : null;
  const avatarSvgIcon3RenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatar?.id === 'avatarSvgIcon3'
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.family_avatar?.id === 'avatarSvgIcon3'
        : null;
  const avatarSvgIcon4RenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatar?.id === 'avatarSvgIcon4'
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.family_avatar?.id === 'avatarSvgIcon4'
        : null;

  const NoAvatarSvgIconRenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatar?.id === undefined
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.family_avatar?.id === undefined
        : null;

  const avatarSvgSkinToneRenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatarSkinTone?.colorCode
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.avatarFamilySkinTone?.colorCode
        : '';

  const avatarSvgHairColorRenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatarHairColor?.colorCode
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.avatarFamilyHairColor?.colorCode
        : '';

  const avatarSvgShirtColorRenderCondition =
    chooseAvatarPictureRedirection === '/enrollment/profile/edit'
      ? chooseAvatarPicture?.avatarShirtColor?.colorCode
      : chooseAvatarPictureRedirection === '/enrollment/family'
        ? chooseAvatarPicture?.avatarFamilyShirtColor?.colorCode
        : '';

  return (
    <StyledAvatar>
      {avatarSvgIcon1RenderCondition && (
        <DisplayAvatarIcon1
          skinTone={avatarSvgSkinToneRenderCondition}
          hairColor={avatarSvgHairColorRenderCondition}
          shirtColor={avatarSvgShirtColorRenderCondition}
        />
      )}
      {avatarSvgIcon2RenderCondition && (
        <DisplayAvatarIcon2
          skinTone={avatarSvgSkinToneRenderCondition}
          hairColor={avatarSvgHairColorRenderCondition}
          shirtColor={avatarSvgShirtColorRenderCondition}
        />
      )}
      {avatarSvgIcon3RenderCondition && (
        <DisplayAvatarIcon3
          skinTone={avatarSvgSkinToneRenderCondition}
          hairColor={avatarSvgHairColorRenderCondition}
          shirtColor={avatarSvgShirtColorRenderCondition}
        />
      )}
      {avatarSvgIcon4RenderCondition && (
        <DisplayAvatarIcon4
          skinTone={avatarSvgSkinToneRenderCondition}
          hairColor={avatarSvgHairColorRenderCondition}
          shirtColor={avatarSvgShirtColorRenderCondition}
        />
      )}
      {NoAvatarSvgIconRenderCondition && <DisplayNoAvatarIcon />}
    </StyledAvatar>
  );
};
